import { MUNSELL_HUES } from '@/color/constants/munsellHues';
export const HUE_SEGMENT_SIZE = 360 / MUNSELL_HUES.length;
// make center of 5R at top center
export const HUE_WHEEL_ROTATION = -(HUE_SEGMENT_SIZE / 2);
